import { createContext, useContext, type ReactNode } from 'react'
import { useAuthSession } from '@/shared/hooks/useAuthSession'

interface AuthContextType {
  session: any | null
  user: any | null
  loading: boolean
  signOut: () => Promise<any>
}

const AuthContext = createContext<AuthContextType | undefined>(undefined)

export function AuthProvider({ children }: { children: ReactNode }) {
  const authSession = useAuthSession()

  return (
    <AuthContext.Provider value={authSession}>
      {children}
    </AuthContext.Provider>
  )
}

export function useAuth() {
  const context = useContext(AuthContext)

  if (!context) {
    throw new Error('useAuth must be used within AuthProvider')
  }

  return context
}